import * as React from 'react';
import {useEffect, useContext} from 'react';
import {Profile} from '../queries/Profile';
import {GodFatherContext} from '../state/associationContext';
import {nextcloud as nextcloudAxios, secured as axios} from '../../../axios';
import keycloak from '../../../Keycloak';
import jwt from 'jwt-decode';
import moment from 'moment';
import {create} from '@mui/material/styles/createTransitions';
import {nextcloud} from '../../../axios';

export const useGodFather = () => {
  const {state, dispatchFather} = useContext(GodFatherContext);

  const init = async () => {
    const parents = await Profile.getGodFather();
    dispatchFather &&
      dispatchFather({type: 'initGodFatherList', payload: parents});
    const surrounding = await Profile.getSurroundings();
    await Promise.all(
      [...parents, ...surrounding].map(contact =>
        createContact(
          contact.lastname,
          contact.firstname,
          contact.email,
          !!contact.image ? contact.image.base64 : '',
        ),
      ),
    );
  };

  const getUserId = () => {
    try {
      const decodedToken = jwt(keycloak.token);
      return decodedToken.sub;
    } catch {
      return null;
    }
  };

  const createContact = async (
    lastname,
    firstname,
    email,
    photo = '',
    address = '',
    phoneNumber = '',
  ) => {
    const contactUser = await axios
      .get(`/nextcloud/users?email=${email}`, {})
      .then(res => res.data);
    const [contactId] = contactUser;

    if (!contactId) return;
    let [, id] = contactId.split('keycloak-'); // ex: keycloak-57a274df-8b80-4756-a764-30e9549c1698 so we remove the keycloak- part
    id = id ?? contactId; // if the id is not found, we use the contactId as id

    const updateTime = moment().format('DDMMYY');
    const userId = getUserId();
    const body = `BEGIN:VCARD\nVERSION:4.0\nPRODID:-//Nextcloud Contacts v5.5.1\nUID:${id}\nFN:${
      firstname ?? ''
    } ${
      lastname ?? ''
    }\nADR;TYPE=HOME:;;${address};;;;\nEMAIL;TYPE=HOME:${email}\nTEL;TYPE=HOME:${phoneNumber}\nTITLE:\nORG:\nPHOTO:${photo}\nREV;VALUE=DATE-AND-OR-TIME:${updateTime}\nEND:VCARD`;

    return await nextcloudAxios.put(
      `/remote.php/dav/addressbooks/users/${userId}/contacts/${id}.vcf`,
      body,
      {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
          'Content-type': 'text/vcard; charset=UTF-8',
          Accept: '*/*',
        },
      },
    );
  };

  useEffect(() => {
    state?.length === 0 && init();
  }, []);

  const linkAccountGodFather = async (mail, type) => {
    return await Profile.linkAccount(mail, type).then(res => {
      if (res.status === 200) {
        return true;
      }
      if (res.status !== 200) {
        throw new Error(res.data.message);
      }
    });
  };

  const unlinkAccount = mail => {
    Profile.unlinkAccount(mail).then(status => {
      if (status === 204) {
        dispatchFather({type: 'removeGodFather', payload: mail});
      }
    });
  };

  return {
    godFathers: state,
    linkAccountGodFather,
    unlinkAccount,
    initializeContacts: init,
  };
};
